import { createWebHistory, createRouter, RouteRecordRaw } from 'vue-router';

import Sidebar from '@/components/Sidebar/Sidebar.vue';
import Toolbar from '@/components/Toolbar/Toolbar.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/auth',
    children: [
      {
        path: 'login',
        name: "LoginView",
        component: () => import('@/pages/Auth/Login.vue'),
      },
    ],
  },
  {
    path: '/',
    name: "HomeView",
    components: {
      default: () => import('@/pages/Home/Home.vue'),
      Sidebar: () => import('@/components/Sidebar/Sidebar.vue'),
      Toolbar: () => import('@/components/Toolbar/Toolbar.vue'),
    },
    children: [
      {
        path: ":store_id",
        children: [
          {
            path: "",
            name: "StoreView",
            components: {
              default: () => import('@/pages/Store/Store.vue'),
              Sidebar,
              Toolbar: () => import('@/components/Toolbar/Toolbar.vue'),
            },
          },
        ],
      },
    ],
  },
  {
    path: "/:store_id",
    children: [
      {
        path: 'products',
        name: "ProductsView",
        components: {
          default: () => import('@/pages/Products/Products.vue'),
          Sidebar,
          Toolbar: () => import('@/components/Toolbar/Toolbar.vue'),
        },
        children: [
          {
            path: 'inventory',
            name: "InventoryView",
            component: () => import('@/pages/Products/Inventory/Inventory.vue'),
          },
          {
            path: 'categories',
            name: "CategoryView",
            component: () => import('@/pages/Products/Category/Category.vue'),
          },
        ],
      },
      {
        path: 'mini-store',
        name: "MiniStoreView",
        components: {
          default: () => import('@/pages/MiniStore/MiniStore.vue'),
          Sidebar: () => import('@/components/Sidebar/Sidebar.vue'),
          Toolbar: () => import('@/components/Toolbar/Toolbar.vue'),
        },
        children: [
          {
            path: 'customization',
            name: "CustomizationView",
            component: () => import('@/pages/MiniStore/Customization/Customization.vue'),
          },
        ],
      },
      {
        path: 'game',
        components: {
          default: () => import('@/pages/Game/Game.vue'),
          Sidebar: () => import('@/components/Sidebar/Sidebar.vue'),
          Toolbar: () => import('@/components/Toolbar/Toolbar.vue'),
        },
        children: [
          {
            path: 'lottery',
            name: "LotteryView",
            component: () => import('@/pages/Game/Lottery/Lottery.vue'),
          },
          {
            path: 'promo',
            name: "PromoCodeView",
            component: () => import('@/pages/Game/PromoCode/PromoCode.vue'),
          },
          {
            path: 'lootbox',
            name: "LootBoxView",
            component: () => import('@/pages/Game/LootBox/index.vue'),
          },
        ],
      },
      {
        path: 'settings',
        name: "SettingsView",
        components: {
          default: () => import('@/pages/Settings/Settings.vue'),
          Sidebar: () => import('@/components/Sidebar/Sidebar.vue'),
          Toolbar: () => import('@/components/Toolbar/Toolbar.vue'),
        },
      },
    ],
  },
  {
    path: '/sass-creators',
    components: {
      default: () => import('@/pages/SassCreators/SassCreators.vue'),
      Sidebar: () => import('@/components/Sidebar/Sidebar.vue'),
      Toolbar: () => import('@/components/Toolbar/Toolbar.vue'),
    },
    children: [
      {
        path: 'subscriptions',
        component: () => import('@/pages/SassCreators/Subscriptions/Subscriptions.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
